// @flow
import React from "react";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import type { Team } from "../../common/types";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Switch from "@material-ui/core/Switch";
import _ from "lodash";
import Typography from "@material-ui/core/Typography";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

type Props = {
  teams: [Team],
  setChecked: Function,
  checked: [string],
  open: boolean,
  onClose: Function,
  onOpen: Function,
};

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

function ScheduleFilter({
  teams,
  onClose,
  onOpen,
  open,
  checked,
  setChecked,
}: Props) {
  const classes = useStyles();

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const teamsSorted = _.sortBy(teams, ["name"]);

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      disableBackdropTransition={!iOS}
      disableDiscovery={true}
      disableSwipeToOpen={true}
    >
      <Container maxWidth="sm">
        <div
          style={{
            margin: "0 auto",
            width: 36,
            height: 5,
            backgroundColor: "#C4C4C4",
            borderRadius: 3,
            marginTop: 7,
            marginBottom: 7,
          }}
        />
        <Box className={classes.wrapper}>
          <List
            subheader={
              <ListSubheader>Filtere die Spiele nach Teams</ListSubheader>
            }
          >
            {teamsSorted.map((team) => (
              <ListItem key={team.id}>
                <ListItemText
                  primary={team.name}
                  id={`switch-list-label-${team.name.trim()}`}
                />
                <ListItemSecondaryAction>
                  <Switch
                    edge="end"
                    onChange={handleToggle(team.id)}
                    checked={checked.indexOf(team.id) !== -1}
                    inputProps={{
                      "aria-labelledby": `switch-list-label-${team.name.trim()}`,
                    }}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            ))}
            <ListSubheader>
              <Box className={classes.footer} mt={2}>
                <CheckCircleIcon
                  color="primary"
                  fontSize="small"
                  style={{ marginRight: 5 }}
                />
                <Typography color="primary" variant="caption">
                  Dein Filter wird für dich gespeichert
                </Typography>
              </Box>
            </ListSubheader>
          </List>
        </Box>
      </Container>
    </SwipeableDrawer>
  );
}

const useStyles = makeStyles({
  wrapper: {
    paddingBottom: 20,
    marginBottom: "env(safe-area-inset-bottom)",
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

export default ScheduleFilter;
